
import {ExternalLink} from './externalLink';
import {JsonObject, JsonProperty} from 'json2typescript';
import {ExternalLinkConverter} from '../../customJsonConverters/ExternalLinkConverter';

@JsonObject('SocialMedia')
export abstract class SocialMedia {


    @JsonProperty('shareClass',String,true)
    public shareClass = '';

    @JsonProperty('clickArea',String,true)
    public clickArea = '';

    @JsonProperty('configFile',String,true)
    public configFile = '';

    @JsonProperty('link',ExternalLinkConverter)
    public link = new ExternalLink();

    @JsonProperty('image',String,true)
    public image = '';


 protected constructor() {
   //  this.link = new ExternalLink();
 }

}
